import { Stack } from '@mui/material';
import { SiteActivity, SiteActivityProps } from './site-activity';

export type SiteActivityTabProps = Partial<SiteActivityProps>;

export const SiteActivityTab = ({ addressId, partnerId }: SiteActivityTabProps) => {
  if (!addressId || !partnerId) {
    return null;
  }
  return (
    <Stack spacing={2}>
      <SiteActivity addressId={addressId} partnerId={partnerId} />
    </Stack>
  );
};
